import { Folder } from "../stores/folderStore";

export const SYSTEM_FOLDER_ORDER: Record<string, number> = {
  inbox: 1,
  "bandeja de entrada": 1,
  enviados: 2,
  sent: 2,
  borradores: 3,
  drafts: 3,
  destacados: 4,
  flagged: 4,
  spam: 5,
  junk: 5,
  archivo: 6,
  archive: 6,
  papelera: 7,
  trash: 7,
};

export const SYSTEM_FLAGS = new Set([
  "\\inbox",
  "\\sent",
  "\\drafts",
  "\\trash",
  "\\junk",
  "\\flagged",
  "\\archive",
  "\\important",
]);

export const ICON_MAP: Record<string, string> = {
  INBOX: "inbox",
  "Bandeja de entrada": "inbox",
  Enviados: "send",
  Sent: "send",
  Borradores: "file-text",
  Drafts: "file-text",
  Papelera: "trash-2",
  Trash: "trash-2",
  Spam: "alert-triangle",
  Junk: "alert-triangle",
  Destacados: "star",
  Flagged: "star",
  Archivo: "folder",
  Archive: "folder",
};

export function getSystemDisplayName(pathOrName: string): string {
  const p = pathOrName.toLowerCase();
  if (p === "inbox" || p === "bandeja de entrada") return "Bandeja de entrada";
  if (p === "sent" || p === "enviados") return "Enviados";
  if (p === "drafts" || p === "borradores") return "Borradores";
  if (p === "trash" || p === "papelera") return "Papelera";
  if (p === "junk" || p === "spam") return "Spam";
  if (p === "flagged" || p === "destacados") return "Destacados";
  if (p === "archive" || p === "archivo") return "Archivo";
  return pathOrName;
}

export function isSystemFolder(f: { path: string; name: string; flags?: string[] }): boolean {
  const pathLower = f.path.toLowerCase();
  const nameLower = f.name.toLowerCase();
  if (
    pathLower === "inbox" ||
    nameLower === "inbox" ||
    pathLower === "sent" ||
    nameLower === "sent" ||
    pathLower === "enviados" ||
    nameLower === "enviados" ||
    pathLower === "drafts" ||
    nameLower === "drafts" ||
    pathLower === "borradores" ||
    nameLower === "borradores" ||
    pathLower === "trash" ||
    nameLower === "trash" ||
    pathLower === "papelera" ||
    nameLower === "papelera" ||
    pathLower === "junk" ||
    nameLower === "junk" ||
    pathLower === "spam" ||
    nameLower === "spam" ||
    pathLower === "flagged" ||
    nameLower === "flagged" ||
    pathLower === "destacados" ||
    nameLower === "destacados" ||
    pathLower === "archive" ||
    nameLower === "archive" ||
    pathLower === "archivo" ||
    nameLower === "archivo"
  ) {
    return true;
  }
  return f.flags ? f.flags.some((flag) => SYSTEM_FLAGS.has(flag.toLowerCase())) : false;
}

export function normalizeFolders(rawFolders: Array<any>): Folder[] {
  const folders: Folder[] = rawFolders.map((f) => {
    const isSys = isSystemFolder(f);
    const displayName = isSys ? getSystemDisplayName(f.name || f.path) : f.name || f.path;
    return {
      id: f.path,
      name: displayName,
      type: isSys ? "system" : "custom",
      icon: ICON_MAP[displayName] || ICON_MAP[f.name] || ICON_MAP[f.path] || "folder",
      unreadCount: f.unread || 0,
      totalCount: f.total || 0,
    };
  });

  // Sort: System folders first by canonical order, then custom folders alphabetically
  return folders.sort((a, b) => {
    if (a.type === "system" && b.type === "system") {
      const orderA = SYSTEM_FOLDER_ORDER[a.name.toLowerCase()] || SYSTEM_FOLDER_ORDER[a.id.toLowerCase()] || 99;
      const orderB = SYSTEM_FOLDER_ORDER[b.name.toLowerCase()] || SYSTEM_FOLDER_ORDER[b.id.toLowerCase()] || 99;
      return orderA - orderB;
    }
    if (a.type === "system") return -1;
    if (b.type === "system") return 1;
    return a.name.localeCompare(b.name);
  });
}
